var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppStoreIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116.023,
    height: 37.953,
    viewBox: "0 0 116.023 37.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App_Store_Icon",
    "data-name": "App Store Icon",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M212.664,968.648a5.129,5.129,0,0,1-5.128,5.129H101.77a5.129,5.129,0,0,1-5.129-5.129V940.954a5.129,5.129,0,0,1,5.129-5.129H207.537a5.128,5.128,0,0,1,5.128,5.129Z",
    transform: "translate(-96.64 -935.825)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1342",
    "data-name": "Group 1342",
    transform: "translate(7.784 5.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M154.11,1002.949a18.8,18.8,0,0,1-1.7,3.172c-1.1,1.68-2.659,3.772-4.585,3.79-1.713.016-2.152-1.115-4.476-1.1s-2.809,1.122-4.522,1.106c-1.927-.018-3.4-1.907-4.5-3.587-3.086-4.7-3.408-10.209-1.505-13.14a6.828,6.828,0,0,1,5.492-3.3c2.042,0,3.327,1.12,5.015,1.12,1.638,0,2.636-1.122,5-1.122a6.665,6.665,0,0,1,5.024,2.653A5.749,5.749,0,0,0,154.11,1002.949Z",
    transform: "translate(-131.637 -983.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1341",
    "data-name": "Group 1341",
    transform: "translate(10.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M184.3,966.6a5.732,5.732,0,0,0,1.273-4.246,6.194,6.194,0,0,0-4,2.151,5.322,5.322,0,0,0-1.307,4.142A5.228,5.228,0,0,0,184.3,966.6Z",
    transform: "translate(-180.207 -962.355)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1345",
    "data-name": "Group 1345",
    transform: "translate(35.237 5.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1343",
    "data-name": "Group 1343",
    transform: "translate(0 9.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M259.5,1004.42l-4.42,13.011h2.024l1.319-4h4.28l1.357,4h2.08L261.7,1004.42Zm1.049,2.139c.149.581.31,1.184.517,1.836l1.191,3.45h-3.39l1.175-3.472C260.223,1007.809,260.392,1007.2,260.551,1006.559Z",
    transform: "translate(-255.082 -1004.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    d: "M313.022,1019.586a3.683,3.683,0,0,0-3.129,1.5l-.079-1.294h-1.8l.011.165c.053.806.075,1.693.075,2.967v10.028h1.969v-4.68a3.457,3.457,0,0,0,2.691,1.156,4.058,4.058,0,0,0,2.983-1.268,5.377,5.377,0,0,0,1.317-3.786,5.236,5.236,0,0,0-1.144-3.457A3.745,3.745,0,0,0,313.022,1019.586Zm-.49,1.63c1.755,0,2.54,1.626,2.54,3.236,0,2.078-1,3.368-2.615,3.368a2.387,2.387,0,0,1-2.319-1.827,2.509,2.509,0,0,1-.07-.637v-1.583a2.967,2.967,0,0,1,.062-.486c.01-.054.02-.108.028-.16A2.493,2.493,0,0,1,312.532,1021.216Z",
    transform: "translate(-296.242 -1016.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "M358.6,1019.586a3.685,3.685,0,0,0-3.13,1.5l-.078-1.294h-1.8l.01.165c.053.807.076,1.693.076,2.967v10.028h1.969v-4.68a3.455,3.455,0,0,0,2.69,1.156,4.064,4.064,0,0,0,2.984-1.268,5.384,5.384,0,0,0,1.316-3.786,5.237,5.237,0,0,0-1.144-3.457A3.744,3.744,0,0,0,358.6,1019.586Zm-.49,1.63c1.754,0,2.539,1.626,2.539,3.236,0,2.078-1,3.368-2.615,3.368a2.387,2.387,0,0,1-2.319-1.827,2.513,2.513,0,0,1-.069-.637v-1.583a2.922,2.922,0,0,1,.063-.487c.01-.053.02-.106.028-.158A2.491,2.491,0,0,1,358.114,1021.216Z",
    transform: "translate(-331.687 -1016.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M416.831,1009.208c-1.837-.711-2.426-1.271-2.426-2.3,0-.87.692-1.748,2.237-1.748a4.474,4.474,0,0,1,2.311.58l.167.1.556-1.643-.11-.064a5.7,5.7,0,0,0-2.867-.643c-2.51,0-4.264,1.482-4.264,3.6,0,1.711,1.1,2.907,3.455,3.764,1.671.624,2.292,1.264,2.292,2.361,0,1.241-.959,2.011-2.5,2.011a5.388,5.388,0,0,1-2.837-.8l-.171-.109-.528,1.681.1.064a6.742,6.742,0,0,0,3.327.855c3.383,0,4.583-2.063,4.583-3.829C420.152,1011.262,419.19,1010.139,416.831,1009.208Z",
    transform: "translate(-377.216 -1003.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M452.389,1010.439l-1.931.606v1.635h-1.413v1.573h1.413v4.819a3.684,3.684,0,0,0,.682,2.5,2.523,2.523,0,0,0,1.9.748,4.64,4.64,0,0,0,1.522-.235l.11-.039-.094-1.576-.189.058a2.967,2.967,0,0,1-.916.106c-.763,0-1.089-.483-1.089-1.616v-4.762h2.375v-1.573h-2.375Z",
    transform: "translate(-405.909 -1008.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M480.34,1019.586c-2.754,0-4.678,2.056-4.678,5,0,2.854,1.861,4.847,4.527,4.847h.018a4.641,4.641,0,0,0,4.678-5.017,4.973,4.973,0,0,0-1.254-3.482A4.38,4.38,0,0,0,480.34,1019.586Zm-.057,1.554c1.771,0,2.577,1.726,2.577,3.331,0,1.973-1.1,3.405-2.614,3.405h-.019c-1.493,0-2.576-1.408-2.576-3.348C477.65,1022.842,478.464,1021.14,480.283,1021.14Z",
    transform: "translate(-426.607 -1016.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M527.111,1019.677l-.118-.03a1.9,1.9,0,0,0-.49-.061,2.808,2.808,0,0,0-2.468,1.585l-.058-1.378h-1.766l.011.165c.052.779.074,1.654.074,2.835l-.018,6.431h1.968v-5.017a5.076,5.076,0,0,1,.054-.763,2.176,2.176,0,0,1,2.071-1.984,5.049,5.049,0,0,1,.528.033l.211.022Z",
    transform: "translate(-462.804 -1016.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M548.582,1019.5c-2.62,0-4.451,2.094-4.451,5.092a4.4,4.4,0,0,0,4.639,4.753,7.548,7.548,0,0,0,3.117-.6l.119-.053-.378-1.467-.164.066a6.1,6.1,0,0,1-2.466.441,2.737,2.737,0,0,1-2.948-2.854l6.354.019.026-.126a4.38,4.38,0,0,0,.059-.822C552.487,1021.9,551.464,1019.5,548.582,1019.5Zm-.131,1.5a1.943,1.943,0,0,1,1.445.551,2.8,2.8,0,0,1,.678,1.833h-4.49A2.512,2.512,0,0,1,548.451,1021Z",
    transform: "translate(-479.849 -1015.941)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1344",
    "data-name": "Group 1344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M255.082,964.009a14.35,14.35,0,0,1,1.888-.128,4.213,4.213,0,0,1,2.772.758,2.7,2.7,0,0,1,.975,2.22,3.117,3.117,0,0,1-.985,2.394,4.568,4.568,0,0,1-3.035.886,13.66,13.66,0,0,1-1.614-.073Zm.894,5.454a6.327,6.327,0,0,0,.893.037c1.888.009,2.913-.95,2.913-2.613.01-1.471-.9-2.376-2.771-2.376a5.607,5.607,0,0,0-1.035.082Z",
    transform: "translate(-255.082 -963.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M286.419,976.063a2.219,2.219,0,0,1-2.355-2.275,2.281,2.281,0,0,1,2.436-2.348,2.2,2.2,0,0,1,2.365,2.266,2.289,2.289,0,0,1-2.436,2.357Zm.03-.6a1.573,1.573,0,0,0,1.492-1.727,1.5,1.5,0,1,0-1.5,1.727Z",
    transform: "translate(-277.619 -969.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M308.814,971.891l.66,2.239c.132.493.264.959.355,1.416h.03c.112-.448.274-.923.437-1.407l.8-2.248h.751l.761,2.211c.182.521.325,1,.436,1.444h.03a12.241,12.241,0,0,1,.376-1.434l.7-2.22h.884l-1.584,4.422h-.812l-.751-2.11a14.469,14.469,0,0,1-.437-1.462h-.02a12.149,12.149,0,0,1-.447,1.471l-.791,2.1h-.812l-1.482-4.422Z",
    transform: "translate(-296.154 -969.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M343.869,972.737c0-.466-.01-.831-.041-1.2h.792l.05.722h.02a1.861,1.861,0,0,1,1.624-.822,1.682,1.682,0,0,1,1.736,1.882v2.64h-.893v-2.549c0-.713-.295-1.315-1.138-1.315a1.274,1.274,0,0,0-1.2.822,1.082,1.082,0,0,0-.061.375v2.668h-.893Z",
    transform: "translate(-324.092 -969.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M369.346,962.607h.893v6.486h-.893Z",
    transform: "translate(-343.935 -962.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M380.787,976.063a2.22,2.22,0,0,1-2.355-2.275,2.281,2.281,0,0,1,2.436-2.348,2.2,2.2,0,0,1,2.365,2.266,2.289,2.289,0,0,1-2.436,2.357Zm.03-.6a1.573,1.573,0,0,0,1.493-1.727,1.5,1.5,0,1,0-1.5,1.727Z",
    transform: "translate(-351 -969.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M407.2,974.9a6.664,6.664,0,0,0,.071,1.06h-.8l-.081-.557h-.03a1.889,1.889,0,0,1-1.5.658,1.339,1.339,0,0,1-1.5-1.27c0-1.069,1.055-1.654,2.954-1.645v-.091c0-.365-.111-1.032-1.116-1.023a2.564,2.564,0,0,0-1.289.329l-.2-.539a3.46,3.46,0,0,1,1.625-.384,1.644,1.644,0,0,1,1.878,1.809Zm-.873-1.2c-.974-.018-2.081.137-2.081,1a.747.747,0,0,0,.832.768,1.239,1.239,0,0,0,1.208-.74.738.738,0,0,0,.041-.256Z",
    transform: "translate(-370.382 -969.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M430.094,962.607v5.344c0,.393.011.84.041,1.142h-.8l-.04-.767h-.02a1.838,1.838,0,0,1-1.665.868,2.109,2.109,0,0,1-2.112-2.248,2.2,2.2,0,0,1,2.2-2.375,1.69,1.69,0,0,1,1.483.667h.02v-2.631Zm-.893,3.865a1.338,1.338,0,0,0-.041-.347,1.291,1.291,0,0,0-1.289-.923,1.513,1.513,0,0,0-1.472,1.7,1.467,1.467,0,0,0,1.452,1.644,1.329,1.329,0,0,0,1.309-.959,1.252,1.252,0,0,0,.041-.347Z",
    transform: "translate(-387.597 -962.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M463.275,976.063a2.22,2.22,0,0,1-2.355-2.275,2.281,2.281,0,0,1,2.436-2.348,2.2,2.2,0,0,1,2.366,2.266,2.289,2.289,0,0,1-2.436,2.357Zm.031-.6a1.573,1.573,0,0,0,1.492-1.727,1.5,1.5,0,1,0-1.5,1.727Z",
    transform: "translate(-415.143 -969.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M487.439,972.737c0-.466-.01-.831-.041-1.2h.792l.051.722h.02a1.861,1.861,0,0,1,1.624-.822,1.682,1.682,0,0,1,1.736,1.882v2.64h-.894v-2.549c0-.713-.294-1.315-1.137-1.315a1.276,1.276,0,0,0-1.2.822,1.088,1.088,0,0,0-.061.375v2.668h-.893Z",
    transform: "translate(-435.733 -969.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M521.719,967.127v1.059H523v.612h-1.279v2.385c0,.548.173.859.67.859a1.838,1.838,0,0,0,.518-.055l.04.612a2.682,2.682,0,0,1-.792.11,1.353,1.353,0,0,1-.965-.338,1.605,1.605,0,0,1-.345-1.161V968.8h-.761v-.612h.761v-.813Z",
    transform: "translate(-461.15 -966.122)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M537.705,962.607h.893v2.759h.021a1.517,1.517,0,0,1,.64-.566,1.885,1.885,0,0,1,.914-.228,1.681,1.681,0,0,1,1.715,1.891v2.631h-.893v-2.54c0-.722-.294-1.315-1.137-1.315a1.284,1.284,0,0,0-1.2.8.884.884,0,0,0-.061.384v2.668h-.893Z",
    transform: "translate(-474.852 -962.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M562.306,973.856a1.5,1.5,0,0,0,1.675,1.535,3.725,3.725,0,0,0,1.361-.22l.162.566a4.393,4.393,0,0,1-1.645.283,2.179,2.179,0,0,1-2.417-2.229,2.251,2.251,0,0,1,2.314-2.394,1.935,1.935,0,0,1,2.02,2.083,1.858,1.858,0,0,1-.03.383Zm2.61-.576a1.186,1.186,0,0,0-1.229-1.307,1.391,1.391,0,0,0-1.37,1.307Z",
    transform: "translate(-493.311 -969.443)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreIcon);
export default __webpack_public_path__ + "static/media/app-store-icon.23806dbe42a688736a532eb1d3aa33dc.svg";
export { ForwardRef as ReactComponent };